import React from 'react';
import { Link } from 'react-router-dom';
import HttpManager from '../utils/HttpManager';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Registration from './Registration';
import Swal from 'sweetalert2'


function VerifyEmail() {
    const navigate = useNavigate();
    const [emailVerificationCode, setemailVerificationCode] = useState('');
    const [errors, setErrors] = useState({});

    const VerifyEmailCode = async () => {
        const newErrors = {};

        if (!emailVerificationCode.trim()) newErrors.emailVerificationCode = 'Verification code is required';

        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            let emailVerificationResponse;

            try {
                emailVerificationResponse = await new HttpManager(navigate).post('/User/VerifyEmail?emailVerificationCode=' + emailVerificationCode, JSON.parse(localStorage.getItem("Registration")));

                if (emailVerificationResponse.IsSuccess && emailVerificationResponse.Message === "Email verification successfully done")
                    navigate('/UpdateCredentials'); // 👈 Navigate to /register
                else if (emailVerificationResponse.IsSuccess && emailVerificationResponse.Message === "Email verification already done")
                    navigate('/Dashboard'); // 👈 Navigate to /register
                else
                    Swal.fire({
                        title: "Email Verification Failed",
                        text: emailVerificationResponse.Message,
                        icon: "error"
                    });
            }
            catch (error) {

                Swal.fire({
                    title: "Email Verification Failed",
                    text: "Email verification failed due to technical issue, kindly try after sometime",
                    icon: "error"
                });
            }

        }
    };

    return (
        <div className="d-flex justify-content-center align-items-center vh-100 w-100">
            <main className="w-100 m-auto">
                <form className='col-md-6 offset-md-3'>
                    <h4 className="h5 mb-3 fw-normal">
                        We have sent an email verification code to your registered email address. Kindly submit the verification code to complete the registraton successfully.
                    </h4>

                    <div className="col-md-3 form-floating my-3">
                        <input
                            type="text"
                            className={`form-control ${errors.emailVerificationCode ? 'is-invalid' : ''}`}
                            id="txtEmailVerificationCode"
                            placeholder="Verification Code"
                            value={emailVerificationCode}
                            onChange={(e) => setemailVerificationCode(e.target.value)}
                        />
                        <label htmlFor="txtEmailVerificationCode">Email Verification Code</label>
                        {errors.emailVerificationCode && <div className="invalid-feedback">{errors.emailVerificationCode}</div>}
                    </div>

                    <button className="btn btn-primary col-md-3 py-2" type="button" onClick={VerifyEmailCode}>
                        Verify Email
                    </button>
                    <p className="mt-5 mb-3 text-body-secondary">decipherX © 2026</p>
                </form>
            </main>
        </div>
    );
}


export default VerifyEmail;
